
export const fontStyles = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: '300',
  lineHeight: '1.5rem',
};

export const marketingFontStyles = {
  ...fontStyles,
  color: 'inherit'
};

export const headerDiv = {
  textAlign: 'center'
};

export const h1Styles = {
  ...fontStyles,
  marginBottom: '1.35rem',
  fontSize: '2rem',
  letterSpacing: '1.5px'
};

export const h5Styles = {
  ...fontStyles,
  fontSize: '1.15rem',
  letterSpacing: '.5px'
};

export const h4Styles = {
  ...fontStyles,
  marginBottom:'1.5rem',
  lineHeight: '1.5rem'
};

export const imageRightRowStyles = {
  flexDirection: 'row-reverse'
};

export const imageRightStyles = (imgUrl) => {
  return {
    background: `url(${imgUrl}) no-repeat right top`,
    backgroundSize: 'cover',
    padding: '12vh 10vw 12vh 8vw'
  };

};

export const marketingContentStyles = {
  padding: '12vh 10vw 12vh 8vw',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
};

export const marketingHeaderStyles = {
  ...marketingFontStyles,
  marginBottom: '.7rem',
  lineHeight: '.9em',
  fontSize: '40px',
  fontWeight: '200'
};

export const marketingStrongStyles = {
  ...marketingFontStyles,
  fontSize: '18px'
};

export const marketingParagraphStyles = {
  ...marketingFontStyles,
  fontSize: '18px',
  marginBottom: '1.5rem'
};

export const marketingSubheaderStyles = {
  ...marketingFontStyles,
  lineHeight:'1.5em',
  letterSpacing: '.5px',
  fontSize: '20px'
};

export const longMarketingParagraphStyles = {
  ...marketingFontStyles,
  fontSize: '16px',
  marginTop: 0,
  marginBottom: '1rem',
  lineHeight: '1.5rem'
};

export const paddingTopStyles = {
  paddingTop: '4em'
};
